import { render, staticRenderFns } from "./ComandoVelocidadPantalla.vue?vue&type=template&id=470cc96c&"
import script from "./ComandoVelocidadPantalla.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('470cc96c', component.options)
    } else {
      api.reload('470cc96c', component.options)
    }
    module.hot.accept("./ComandoVelocidadPantalla.vue?vue&type=template&id=470cc96c&", function () {
      api.rerender('470cc96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ComandoVelocidad/ComandoVelocidadPantalla.vue"
export default component.exports